<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { devices } from 'src/stores/lists/devices';
import { os } from 'src/stores/session/native-bridge';
	import { includeDeviceModal, includingDeviceData, inclusionStarted } from 'src/stores/features/inclusion';
	//Components
	import { addDeviceModal } from 'src/stores/device-runtime/firmware-ui';
	import { stop_bluetooth_search_ios } from 'src/services/native_container_requests_ios';
	import { stop_bluetooth_search_android } from 'src/services/native_container_requests_android';
	import { push, replace } from 'svelte-spa-router';
	import { socket_reconnect } from 'src/services/socket';
	//Design system components
	import { Alert, Loader } from '@Shelly/shelly-design-system';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';

	export let inclusionData;

	const isIOS = $os === 'IOS';

	$: if ($includingDeviceData.buttonPressed) {
		console.log('inclusionData', inclusionData);
		const _device = $includingDeviceData;

		if (isIOS) {
			stop_bluetooth_search_ios();
		} else {
			stop_bluetooth_search_android();
		}

		if (typeof $devices[_device.id] !== 'undefined') {
			// device is already associated
			includeDeviceModal.update((state) => {
				return (state = { ...state, show: false });
			});
			includingDeviceData.reset();
			inclusionData.timeoutClear();

			replace('/dash');
			push(`/home/room/${$devices[_device.id].room_id}/devices`);

			setSidePanelState({
				type: 'device',
				id: _device.id,
				open: true,
			});

			//@ToDo: Refactor: Check if WS reconnect is still needed
			socket_reconnect();
		} else {
			// device not yet associated
			inclusionStarted.set(false);
			includeDeviceModal.set({ show: false, step: 0, selected: undefined });
			addDeviceModal.set(true);
			inclusionData.timeoutClear();
		}
	}
</script>

<Alert
	class="mb-s"
	heading={$format('press_button_required', {
		default: 'Please press device button.',
	})}
/>
<Loader size="l" class="d-flex justify-content-center" />
